import { ModePanneau, SysIntegrationCalepinage } from '../model/calepinage.types'

export interface ZoneFormSnapshot {
    typePose: string | null
    typeToiture: string | null
    inclinaison: number | null
    typeVehiculeParking: string | null
}

export class CalepinageMapping {
    /**
     * Dérive le système d'intégration calepinage à partir des champs du formulaire de zone.
     * Couvre TOITURE / OMBRIERE / SOL. Réplique la logique des règles Drools côté back.
     */
    static fromZone(z: ZoneFormSnapshot): SysIntegrationCalepinage | null {
        switch (z.typePose) {
            case 'TOITURE':
                return CalepinageMapping.fromTypeToiture(z.typeToiture, z.inclinaison)
            case 'OMBRIERE':
                return 'OMBRIERE'
            case 'SOL':
                return 'LESTE'
            default:
                return null
        }
    }

    /**
     * Mapping spécifique TOITURE.
     */
    static fromTypeToiture(typeToiture: string | null, inclinaison: number | null): SysIntegrationCalepinage | null {
        if (!typeToiture) return null
        if (typeToiture.startsWith('BAC_ACIER')) return 'BAC_ACIER'
        // TAN avec étanchéité = membrane soudée → toujours SOUDE (donc panneaux en PORTRAIT), aligné
        // sur le back qui classe déjà TAN_ETANCHE en SOUDE (CentraleService.buildToitureProductions
        // et rules_zone.drl). Le front le traitait à tort comme du béton (lesté/paysage à plat) —
        // retour client VIRYA_SUNL-11041.
        if (typeToiture === 'TAN_ETANCHE') return 'SOUDE'
        // Béton terrasse : lesté à plat (paysage), soudé en pente.
        const isFlat = inclinaison != null && inclinaison <= 3
        if (typeToiture === 'BETON') {
            return isFlat ? 'LESTE' : 'SOUDE'
        }
        return null
    }

    /**
     * Mode panneau selon les règles client :
     * - Ombrière, SOUDE → Portrait
     * - BAC ACIER, LESTE → Paysage
     */
    static modePanneau(sys: SysIntegrationCalepinage): ModePanneau {
        switch (sys) {
            case 'OMBRIERE':
            case 'SOUDE':
                return 'PORTRAIT'
            case 'BAC_ACIER':
            case 'LESTE':
                return 'PAYSAGE'
        }
    }
}
